import React, {Fragment} from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
import moment from "moment";

const styles = StyleSheet.create({
    headerContainer: {
         padding:10,
        borderBottomColor: '#C8C8C8',
        borderBottomWidth: 1,
    },
    billTo: {
        color: '#000',
        fontSize: 8,
    },
    cancellationpolicy: {
      color: '#000',
      fontSize: 6,
      fontWeight:100,
  },
  });



  let CancellationModal = (data, StartDate) => {
    let DataNew = "";
    let Value = "";
    let EuroIcon = "";
    let PerIcon = "";

    return (
      <Text>
        {" "}
        {data.map((i, index) => {
          const date = new Date(StartDate);
          date.setDate(date.getDate() - i.day_before_arrival);

          DataNew = moment(date).format("Do MMM YYYY");
          // if(i.day_before_arrival == 1 || i.day_before_arrival== 2){
          //   date.setDate(date.getDate() - i.day_before_arrival);
          //   DataNew = moment(date).format("Do MMM YYYY");
          //  }{

          //   date.setDate(date.getDate() - (i.day_before_arrival - 2));
          //    DataNew = moment(date).format("Do MMM YYYY");
          //   DataNew = "If cancelled or modified " + parseInt(i.day_before_arrival - 2) + " days before date of acccommodations.";
          //   DataNew = "If cancelled or modified " + moment(date).format("Do MMM YYYY") + " days before date of acccommodations.";
          // }
          if (i.penalty == "No Penalty") {
            // Value = 0;
            Value = 0;
            EuroIcon = '';
            PerIcon = '';
          } else if (i.penalty == "Full Amount") {
            // Value = 100;
            Value = '';
            EuroIcon = '';
            PerIcon = 'Full booking amount will be charged.';
          } else if (i.penalty == "Percentage") {
            // Value = i.cancellation_value;
            Value = i.cancellation_value;
            EuroIcon = '';
            PerIcon = '% of booking amount will be charged.';
          } else if (i.penalty == "Nights") {
            //Value = i.cancellation_value;
            Value = i.cancellation_value;
            EuroIcon = <span>€</span>;
            PerIcon = ' amount will be charged.';
          } else if (i.penalty == "Fixed Amount") {
            Value = i.cancellation_value;
            EuroIcon = <span>€</span>;
            PerIcon = ' amount will be charged.';
          }

          if (i.day_before_arrival == -1) {
            DataNew = "No Show";
          }

       //   if (id == i.rate_plan_id) {
            return (
              <Text>
                <Text style={styles.cancellationpolicy}>
                  {index == 0 ? "Before" : "After"} &#x202A;{DataNew}&#x202C;
                </Text>
                <Text style={styles.cancellationpolicy}>
                  {/* Charge {Value}% of booking amount will be charged */}
                  {EuroIcon} {Value}{PerIcon}
                </Text>
              </Text>
            );
          //}
        })}
      </Text>
    );
  };


  const CancellationAccommodation = ({invoice}) => {
console.log()
  //   var startDate = invoice.startDate;
  //  const rowsCancel =   invoice?.cancellationpolicy.slice(0,1).map(item =>{

  //  return <Text style={styles.billTo}>{CancellationModal(item, startDate)} <br/></Text>
  //  }
  //  )
   return (<View style={styles.headerContainer}>{invoice.firstcancellationdate !="" &&(<Text style={styles.billTo}><b>Cancellation Policy: </b>Free Cancellation before {moment(
    invoice.firstcancellationdate
  ).format("D MMM Y")}</Text>)}</View>)
  }

  export default CancellationAccommodation